export class RiskControlViewModal{
    effectiveDate:boolean;
    riskRef:boolean;
    riskArea:boolean;
    riskCategory:boolean;
    riskTitledate:boolean;
    complianceTopicdate:boolean;
    entitiesImpactedto:boolean;
    owner:boolean;
    residualRisk:boolean;
    inherentRating:boolean;
    constructor(){
        this.effectiveDate= true;
        this.riskRef= true;
        this.riskArea= true;
        this.riskCategory= true;
        this.riskTitledate= true;
        this.complianceTopicdate= true;
        this.entitiesImpactedto= true;
        this.owner= true;
        this.inherentRating = true;
        this.residualRisk =true
      
    }
}